var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

function GravityForm(el) {
	var $el = $(el);
	if ($el) {
		var $gform_upload_custom = $el.find('.gform_upload_custom_rules');
		if ($gform_upload_custom) {
			var $description_elm = $gform_upload_custom.find('div.gfield_description');
			var $rules_text_elm = $gform_upload_custom.find('span.gform_fileupload_rules');
			if ($rules_text_elm && $description_elm && $description_elm.text() !== '') {
				$description_elm.hide();
				$rules_text_elm.append($description_elm.text());
			}
		}
	}
}

module.exports = GravityForm;
